export default __webpack_public_path__ + "/dist/images/faq-active.e6750e74c7fc3b460b534bc5f1ade07c.svg";